// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__28PVF","question":"Question_question__2Wsip","description":"Question_description__259QN"};